import script from "./shopPay.vue?vue&type=script&setup=true&lang=js"
export * from "./shopPay.vue?vue&type=script&setup=true&lang=js"

import "./shopPay.vue?vue&type=style&index=0&id=598a3640&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-598a3640"]])

export default __exports__